import { Injectable } from '@angular/core';
import { Service } from './service';
import { DatagridComponent } from '@farris/ui-datagrid';
import { CommandContext, FrameContext } from '@farris/devkit';
@Injectable()
export class DataGridService extends Service {
  /**
   * æ¸ç©ºæå®è¡¨æ ¼çå¾éè¡
   * @param dataGridId -è¦æ¸ç©ºå¾éçè¡¨æ ¼ç»ä»¶id
   * @description åæ¶å¾éå½åè¡¨åææå¾éè¡
   */
  public clearChecks(dataGridId?: string | null) {
    const dataGridIdArray = dataGridId ? dataGridId.split(',').filter((p) => p) : null;
    const gridComponents = this.getFormGridComponents(this.context);
    if (gridComponents && gridComponents.length > 0) {
      gridComponents.forEach((gridComponent: DatagridComponent) => {
        if (dataGridIdArray && dataGridIdArray.length > 0) {
          if (dataGridIdArray.indexOf(gridComponent.id) === -1) {
            return;
          }
        }
        let clearSelections = true;
        if (gridComponent.hasOwnProperty('clearSelectionsWhenDataIsEmpty')) {
          clearSelections = gridComponent['clearSelectionsWhenDataIsEmpty'];
        }
        if (clearSelections) {
          gridComponent.clearCheckeds(true);
        }
      });
    }
    // }
    // }
  }
  /**
   * åæ¶å¾éå é¤çè¡
   * @param ids ids
   * @returns
   * @description åæ¶å¾éå½åç»å®è·¯å¾ä¸æå®æ°æ®ï¼æ¸ç©ºä¸çº§è¡¨æ ¼ä¸­ææå¾éè¡ï¼ä»ä¾å é¤åºæ¯ä½¿ç¨
   */
  public uncheckDeletedRows(ids: any) {
    if (typeof ids === 'string') {
      if (ids.indexOf(',') !== -1) {
        ids = ids.split(',').filter(p => p);
      } else {
        ids = [ids];
      }
    }
    if (!ids || ids.length < 1) {
      return;
    }
    // è·åbindingPathåns
    const frameContext = this.context && this.context.frameContext;
    if (!frameContext) {
      return;
    }
    const appContext = frameContext.appContext;
    const ns = frameContext.namespace;
    const bindingPath = frameContext.viewModel && frameContext.viewModel.bindingPath;
    if (!appContext) {
      return;
    }
    // æ ¹æ®bindingPathè·åææå¯è½çframeContext
    const frameContexts = appContext.frameContextManager.getFrameContextsByNamespace(ns);
    const frameContextsInCurrentBindingPath = frameContexts.filter(frameContext => frameContext && frameContext.viewModel && frameContext.viewModel.bindingPath === bindingPath);
    // è·åè¿äºframeä¸­ææçè¡¨æ ¼ç»ä»¶map
    const gridInCurrentFrame = this.getGridComponentByFrameContexts(frameContextsInCurrentBindingPath);
    if (!gridInCurrentFrame) {
      return;
    }
    // ä¸ä¸ªbindingPathä¸åºè¯¥åªæä¸ä¸ªgrid
    const grid: DatagridComponent = gridInCurrentFrame.pop();
    // æ¸ç©ºå½ä»¤æå¨çframeä¸è¡¨æ ¼çæå®å¾é
    if (grid) {
      grid.unCheckRows(ids, true);
    }
    // æ¸ç©ºä¸çº§è¡¨æ ¼çææå¾éè¡æ°æ®
    const childrenFrameContexts = frameContexts.filter(frameContext => frameContext.viewModel.bindingPath !== bindingPath && frameContext.viewModel.bindingPath.startsWith(bindingPath));
    const childrenGridComponents = this.getGridComponentByFrameContexts(childrenFrameContexts);
    // æ¸ç©ºå½ä»¤æå¨frame
    if (childrenGridComponents && childrenGridComponents.length > 0) {
      childrenGridComponents.forEach((gridComponent: DatagridComponent) => {
        // æ¸ç©ºææå¾é
        gridComponent.checkedRows = [];
      });
    }
  }
  /**
   * åæ¶å¾éè¡
   * @param ids ids
   * @returns
   */
  public uncheckRows(ids: any) {
    if (typeof ids === 'string') {
      ids = [ids];
    }
    if (!ids || ids.length < 1) {
      return;
    }
    const gridComponents = this.getFormGridComponents(this.context);
    if (gridComponents && gridComponents.length > 0) {
      gridComponents.forEach((gridComponent: DatagridComponent) => {
        gridComponent.unCheckRows(ids, true);
      });
    }
  }
  /**
   * æ ¹æ®å½ä»¤ä¸ä¸æè·åå½åå½ä»¤æå¨ç»ä»¶çè¡¨æ ¼å®ä¾
   * @param commandContext å½ä»¤ä¸ä¸æ
   * @returns
   */
  private getFormGridComponents(commandContext: CommandContext) {
    let grids = [];
    const frameContext = commandContext && commandContext.frameContext;
    const appContext = frameContext && frameContext.appContext || null;
    if (appContext) {
      const componentRefs: Map<string, Map<string, any>> = appContext.componentRefs;
      const collect = Array.from(componentRefs.values());// [Map<string,any>,Map<string,any>]
      collect.forEach((item: Map<string, any>) => {
        const components = Array.from(item.values());
        const bindingPath = frameContext;
        const gridComponents = components.filter((component: any) => component instanceof DatagridComponent);
        grids = grids.concat(gridComponents);
      });
    }
    return grids;
  }
  private getGridComponentByFrameContexts(frameContexts: FrameContext[]) {
    return frameContexts.reduce((result, frameContext) => {
      const appContext = frameContext.appContext;
      const frameId = frameContext.frameId;
      // è·åå½åç»ä»¶ä¸ææçç»ä»¶å®ä¾
      const componentsRef = appContext.componentRefs.get(frameId);
      const grids = componentsRef && Array.from(componentsRef.values()).filter((component) => component instanceof DatagridComponent);
      if (grids && grids.length > 0) {
        result = result.concat(grids);
      }
      return result;
    }, []);
  }
}
